import React, { Suspense } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import './App.css';
import { Header } from './Components/Header';
import { Home } from './Components/Home';
import DuplicateHome from './Components/DuplicateHome';
import Life from './Components/Life';
import Culture from './Components/Culture';
import Openings from './Components/Openings';
import { Medscore } from './Components/Medscore';
import { SafeCredits } from './Components/SafeCredits';
import BlogList from './Components/BlogList';
import BlogDetail from './Components/BlogDetail';
import NewsSection from './Components/NewsSection';
import Legal from './Components/Legal';

// Loading spinner component for suspense fallback
const LoadingFallback = () => <div className="loading-spinner">Loading...</div>;

// Main App component
 export function App() {
  return (
    <Router>
      <Suspense fallback={<LoadingFallback />}>
        <div className="app">
          <Routes>
            {/* Define your routes */}
            <Route path="/Home" element={<Home />} />
            <Route path="/Header" element={<Header />} />
            <Route path="/Life" element={<Life />} />
            <Route path="/Culture" element={<Culture />} />
            <Route path="/Openings" element={<Openings />} />
            <Route path="/Medscore" element={<Medscore />} />
            <Route path="/SafeCredits" element={<SafeCredits />} />
             <Route path="/BlogList" element={<BlogList />} />
              <Route path="/BlogDetail" element={<BlogDetail />} />
                <Route path="/NewsSection" element={<NewsSection />} />
            <Route path="/terms-and-conditions" element={<Legal />} />
            <Route path="/privacy-policy" element={<Legal />} />
            <Route path="*" element={<Navigate to="/Home" replace />} />
          </Routes>
        </div>
      </Suspense>
    </Router>
  );
}

export default App;
